import { ArrowRight, BookOpen, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/ebook";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] w-full overflow-hidden bg-[#080808]">
      {/* Ambient plum wash */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_50%_20%,rgba(130,73,55,0.45),transparent_65%)]" aria-hidden />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_100%_100%,rgba(212,175,55,0.08),transparent_60%)]" aria-hidden />
      {/* Diagonal plum stripe */}
      <div className="absolute -left-24 top-1/3 w-[140%] h-40 bg-gradient-to-r from-transparent via-[#824937]/25 to-transparent -rotate-6 blur-3xl" aria-hidden />

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 pt-28 md:pt-36 pb-16 min-h-[100svh] flex flex-col justify-between">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Copy */}
          <div className="lg:col-span-7 order-2 lg:order-1">
            <p className="overline rise-in" style={{ animationDelay: "0.1s" }}>
              Crowned Canvas Creations LLC · Madison, WI
            </p>
            <h1 className="mt-6 rise-in" style={{ animationDelay: "0.2s" }}>
              <span className="block font-serif-display text-[42px] sm:text-6xl lg:text-[92px] leading-[0.98] tracking-tight text-[#F7F1E7]">
                Your story deserves
              </span>
              <span className="block font-serif-display text-[42px] sm:text-6xl lg:text-[92px] leading-[0.98] tracking-tight">
                more than <span className="italic text-[#D4AF37]">a frame.</span>
              </span>
            </h1>
            <p
              className="text-base md:text-lg text-[#F7F1E7]/70 max-w-2xl mt-6 md:mt-8 leading-relaxed font-light rise-in"
              style={{ animationDelay: "0.4s" }}
            >
              Turn the people, moments and milestones that matter most into
              custom artwork created to command attention, spark conversation
              and preserve your story. Where your story becomes a masterpiece.
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap gap-3 mt-9 md:mt-12 rise-in" style={{ animationDelay: "0.55s" }}>
              <Link
                to="/#experiences"
                data-testid="hero-create-btn"
                className="group inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-[#080808] px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all"
              >
                Create Your Masterpiece
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/ebook"
                data-testid="hero-ebook-btn"
                className="group inline-flex items-center justify-center gap-3 border border-[#824937] bg-[#824937]/20 text-[#F7F1E7] px-7 py-4 text-xs uppercase tracking-[0.22em] hover:bg-[#824937]/40 transition-all"
              >
                <BookOpen className="w-4 h-4" />
                Get The Free Photo Guide
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-8 mt-14 pt-8 border-t border-white/10 rise-in" style={{ animationDelay: "0.75s" }}>
              <p className="overline text-white/45">Signature Experiences</p>
              <span className="text-white/70 text-xs uppercase tracking-[0.22em]">Royal Essence</span>
              <span className="text-[#D4AF37]">·</span>
              <span className="text-white/70 text-xs uppercase tracking-[0.22em]">Sovereign Canvas</span>
              <span className="text-[#D4AF37]">·</span>
              <span className="text-white/70 text-xs uppercase tracking-[0.22em]">Majestic Vibes</span>
            </div>
          </div>

          {/* Logo showpiece */}
          <div className="lg:col-span-5 order-1 lg:order-2">
            <div className="relative group rise-in" style={{ animationDelay: "0.15s" }}>
              <div className="absolute -inset-6 bg-[#824937]/30 blur-3xl group-hover:bg-[#824937]/50 transition-colors" aria-hidden />
              <div className="absolute -inset-2 bg-[#D4AF37]/10 blur-2xl" aria-hidden />
              <div className="relative aspect-square max-w-[520px] mx-auto flex items-center justify-center p-6 md:p-8">
                <img
                  src={LOGO_URL}
                  alt="Crowned Canvas Creations logo"
                  className="w-full h-full object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.7)] transition-transform duration-700 group-hover:scale-[1.02]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
